import axios from 'axios';

import { addKeycloakInterceptor } from '@tsl-frontend/tsl-axios';

import { environment } from '@environments/environment';

const studentGateway = axios.create({
    baseURL: environment.gatewayUrl,
    withCredentials: true,
});

addKeycloakInterceptor(studentGateway);

export { studentGateway };
